export const PRICE_WRITE_KEYS = [
  'price',
  'catalog_price',
  'is_price_fixed',
  'is_included_in_budget',
  'reader_custom_price',
  'is_reader_price_fixed',
  'reader_catalog_price_id',
  'effective_catalog_price',
  'reader_prices',
  'prices',
  // Устаревшие синонимы полей договора, которые всё ещё принимает разбор project_contracts.
  'service_custom_price',
  'is_service_price_fixed',
  'is_contractor_included_in_budget',
] as const;

const PRICE_WRITE_KEY_SET = new Set<string>(PRICE_WRITE_KEYS);

function isPlainObject(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

export function omitPriceKeys<T>(value: T): T {
  if (Array.isArray(value)) {
    return value.map((item) => omitPriceKeys(item)) as T;
  }
  if (!isPlainObject(value)) return value;

  const out: Record<string, unknown> = {};
  for (const [key, child] of Object.entries(value)) {
    if (PRICE_WRITE_KEY_SET.has(key)) continue;
    out[key] = omitPriceKeys(child);
  }
  return out as T;
}
